//// https://api.jquery.com/jquery.extend/#jQuery-extend-deep-target-object1-objectN
( function () {
    'use strict';
    jQuery.extend( true, e4.settings, {
        dealersearch: {
            marker: {
                iconUrl: '//maps.google.com/mapfiles/ms/icons/',
                iconFileName: { // https://sites.google.com/site/gmapsdevelopment/
                    vand: 'blue-dot.png', //#6991FD
                    spildevand: 'yellow-dot.png', //#FDF569
                    fjernvarme: 'red-dot.png', //#FD7567
                    biogas: 'green-dot.png', //#00E74D
                    industri: 'purple-dot.png' //#E661AC
                },
                iconFileNameDefault: 'ltblue-dot.png' //#67DEDE
            },
            clusterer: {
                minimumClusterSize: 100,
                maxZoom: 1
            }
        }
    } );
}() );
